import React, { type ReactNode } from "react";

export function Spinner() {
  return <span className="spinner" />;
}

export function Alert({ kind, children }: { kind: "error" | "info" | "success"; children: ReactNode }) {
  return <div className={`alert alert-${kind}`}>{children}</div>;
}

export function ProgressBar({ percent }: { percent: number }) {
  return (
    <div className="progress-track">
      <div className="progress-fill" style={{ width: `${Math.max(0, Math.min(100, percent))}%` }} />
    </div>
  );
}

export function Badge({ tone, children }: { tone: "success" | "warning" | "error" | "neutral" | "info"; children: ReactNode }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function StatusBadge({ status, labels }: { status: string; labels: Record<string, string> }) {
  const toneMap: Record<string, "success" | "warning" | "error" | "neutral" | "info"> = {
    DRAFT: "neutral", INCOMPLETE: "warning", SUBMITTED: "info", DOCUMENT_REVIEW: "info",
    CORRECTION_REQUIRED: "warning", CREDIT_REVIEW: "info", READY_FOR_BANK: "success",
    SENT_TO_BANK: "success", BANK_REVIEW: "info", APPROVED: "success", REJECTED: "error", CLOSED: "neutral",
  };
  return <Badge tone={toneMap[status] || "neutral"}>{labels[status] || status}</Badge>;
}

export function formatMoney(n: number): string {
  if (!n) return "۰";
  return new Intl.NumberFormat("fa-IR").format(n);
}
